import { Toaster, toast } from 'sonner'

export const Sonner = () => {
  return <Toaster richColors position="top-right" />
}

type ToastType = 'default' | 'success' | 'error'

export const showToast = (
  message: string,
  type: ToastType = 'default',
  options?: Parameters<typeof toast>[1],
) => {
  if (type === 'success') {
    toast.success(message, options)
  } else if (type === 'error') {
    toast.error(message, options)
  } else {
    toast(message, options)
  }
}
